// extracted by mini-css-extract-plugin
export default {"body":"main_body__+dhfn","icon":"main_icon__iJrCr","bodyLink":"main_bodyLink__6J5iw","image":"main_image__OmDZi","row":"main_row__8OI2g"};